import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';
import { Auth } from '@angular/fire/auth';

export const authGuard: CanActivateFn = (route, state) => {
  const auth = inject(Auth);
  const router = inject(Router);

  return new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      unsubscribe();
      if (user) {
        resolve(true);
      } else {
        // Store the requested URL in sessionStorage
        sessionStorage.setItem('redirectUrl', state.url);
        resolve(router.createUrlTree(['/login']));
      }
    });
  });
};

export const redirectLoggedInToHome: CanActivateFn = () => {
  const auth = inject(Auth);
  const router = inject(Router);

  return new Promise((resolve) => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      unsubscribe();
      if (user) {
        resolve(router.createUrlTree(['/home']));
      } else {
        resolve(true);
      }
    });
  });
};
